import { useModalForms } from '../../../../modalForms/modalFormsContext';
import { useCouponRules } from '../couponRulesContext';


import { Container } from './style';

export function ButtonNextForm() {
    const { handleConfirmCouponRules } = useCouponRules()
    const { alertButtonToClickHim } = useModalForms()

    return(
        <Container 
            onClick={() => handleConfirmCouponRules()}
            breathButton={alertButtonToClickHim?.breathButton && alertButtonToClickHim?.index === 2}
        >
            Continuar
        </Container>
    )
}
